// import React, { useState } from "react";
// import {
//   TableContainer, Table, Thead, Tbody, Tr, Th, Td, Tfoot,
//   Box, Text, Button, Modal, ModalOverlay, ModalContent,
//   ModalHeader, ModalCloseButton, ModalBody, useDisclosure
// } from "@chakra-ui/react";
// import jsPDF from 'jspdf';
// import autoTable from "jspdf-autotable";
// import api from 'contexts/api'; // ou o caminho correto da sua instância
// import { Accordion, AccordionItem, AccordionButton, AccordionPanel } from "@chakra-ui/react";
// import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons';


// function somarArray(array) {
//   return array.reduce((acc, val) => acc + val, 0);
// }



// function TabelaFinanceira({ dados, filtros }) {

//   const [showReceitas, setShowReceitas] = useState(true);
//   const [showDespesas, setShowDespesas] = useState(true);
//   const [gruposAbertos, setGruposAbertos] = useState({});

//   const toggleGrupo = (grupo) => {
//     setGruposAbertos((prev) => ({
//       ...prev,
//       [grupo]: !prev[grupo]
//     }));
//   };

//   const [detalhesModal, setDetalhesModal] = useState([]);
//   const { isOpen, onOpen, onClose } = useDisclosure();

//   const totalModal = detalhesModal.reduce((acc, item) => {
//     const valor = item.Entrada || item.Saida || item.ValorPago || 0;
//     return acc + valor;
//   }, 0);

//   const meses = [
//     "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
//     "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
//   ];

//   const totalgeraltrue = [];
//   const totalgeralfalse = [];

//   // console.log(dados)

//   // const gruposDRE = [...new Set(dados.map((dado) => dado.GrupoDRE))];
//   const gruposDRE = [...new Set(dados.map((dado) => (dado.GrupoDRE ?? "").trim()))];

//   const gruposTrue = gruposDRE.filter((grupo) =>
//     dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && dado.Despesa)
//   );

//   const gruposFalse = gruposDRE.filter((grupo) =>
//     dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && !dado.Despesa)
//   );


//   console.log(gruposDRE, gruposTrue, gruposFalse)

//   const formatarValor = (valor) => {
//     return new Intl.NumberFormat('pt-BR', {
//       minimumFractionDigits: 2,
//       maximumFractionDigits: 2
//     }).format(valor || 0);
//   };

//   const buscarDetalhes = async (params) => {
//     try {
//       const response = await api.get('/planodeconta/detalhe', { params });
//       setDetalhesModal(response.data || []);
//       onOpen();
//     } catch (err) {
//       console.error("Erro ao buscar detalhes:", err);
//     }
//   };

//   const totalReceitasPorMes = Array(meses.length).fill(0);
//   const totalDespesasPorMes = Array(meses.length).fill(0);

//   dados.forEach(dado => {
//     if (!dado.Meses || !Array.isArray(dado.Meses)) return;

//     dado.Meses.forEach((mes, i) => {
//       const value = mes.ValorTotalPago?.ValorTotalPago || 0;
//       if (dado.Despesa) {
//         totalDespesasPorMes[i] += value;
//       } else {
//         totalReceitasPorMes[i] += value;
//       }
//     });
//   });

//   return (
//     <Box bg={'#5e9ff2'} mb={10}>
//       {/* <Text mb={1} fontSize={{ base: 'sm', md: 'md', lg: 'lg' }} color={'blue'}>(+) Receitas</Text> */}
//       <Table variant="striped" w="100%" size="sm">
//         <Thead>
//           <Tr>
//             <Th textAlign="center" bg="#5e9ff2" textColor="#FFFFFF">Grupo DRE</Th>
//             <Th textAlign="center" bg="#5e9ff2" textColor="#FFFFFF">Plano de Conta</Th>
//             {meses.map((mes, i) => (
//               <Th key={i} textAlign="center" bg="#5e9ff2" textColor="#FFFFFF">{mes}</Th>
//             ))}
//             <Th textAlign="center" bg="#5e9ff2" textColor="#FFFFFF">Total Ano</Th>
//           </Tr>
//         </Thead>

//         <Tbody>
//           {/* RECEITAS */}
//           <Tr
//             bg="blue.100"
//             cursor="pointer"
//             onClick={() => setShowReceitas(!showReceitas)}
//           >
//             <Td colSpan={15}>
//               <Text fontWeight="bold" color="blue.600" fontSize="lg">
//                   {showReceitas ? '−' : '+'} (+) Receitas
//               </Text>
//             </Td>
//           </Tr>

//           {showReceitas && gruposFalse.map((grupo) => {
//             const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && !d.Despesa);
//             const totalValues = Array(meses.length).fill(0);
//             return (
//               <React.Fragment key={grupo}>
//                 <Tr
//                   bg="blue.50"
//                   cursor="pointer"
//                   onClick={() => toggleGrupo(grupo)}
//                 >
//                   <Td colSpan={15}>
//                     <Text fontWeight="semibold">
//                       {gruposAbertos[grupo] ? '−' : '+'} {grupo || "Não Agrupado"}
//                     </Text>
//                   </Td>
//                 </Tr>

//                 {gruposAbertos[grupo] && (
//                   <>
//                     {filtered.map((dado, idx) => {
//                       const mesValues = dado.Meses.map((mes, i) => {
//                         const value = mes.ValorTotalPago?.ValorTotalPago || 0;
//                         totalValues[i] += value;
//                         totalgeraltrue[i] = (totalgeraltrue[i] || 0) + value;
//                         return (
//                           <Td
//                             key={i}
//                             cursor="pointer"
//                             _hover={{ bg: "blue.200" }}
//                             onClick={() => buscarDetalhes({
//                               empresaID: dado.EmpresaID,
//                               planoDeConta: dado.PlanoDeConta,
//                               despesa: dado.Despesa,
//                               mes: mes.Mes,
//                               ano: filtros.ano,
//                               tipoData: filtros.tipoData,
//                               user: filtros.user
//                             })}
//                           >
//                             {formatarValor(value)}
//                           </Td>
//                         );
//                       });

//                       return (
//                         <Tr key={idx}>
//                           <Td></Td>
//                           <Td>{dado.PlanoDeConta}</Td>
//                           {mesValues}
//                           <Td>{formatarValor(somarArray(mesValues.map(td => parseFloat(td.props.children.replace(".", "").replace(",", ".")))))}</Td>
//                         </Tr>
//                       );
//                     })}
//                     <Tr bg="blue.100">
//                       <Td></Td>
//                       <Td><Text fontWeight="bold">Total</Text></Td>
//                       {totalValues.map((v, i) => (
//                         <Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>
//                       ))}
//                       <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
//                     </Tr>
//                   </>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </Tbody>

//         <Tbody>
//           {/* DESPESAS */}
//           <Tr
//             bg="red.100"
//             cursor="pointer"
//             onClick={() => setShowDespesas(!showDespesas)}
//           >
//             <Td colSpan={15}>
//               <Text fontWeight="bold" color="red.600" fontSize="lg">
//                 {/* {showDespesas ? <ChevronDownIcon /> : <ChevronRightIcon />} (-) Despesas */}
//                 {showDespesas? '−' : '+'} (-) Despesas
//               </Text>
//             </Td>
//           </Tr>

//           {showDespesas && gruposTrue.map((grupo) => {
//             const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && d.Despesa);
//             const totalValues = Array(meses.length).fill(0);
//             return (
//               <React.Fragment key={grupo}>
//                 <Tr
//                   bg="red.50"
//                   cursor="pointer"
//                   onClick={() => toggleGrupo(grupo)}
//                 >
//                   <Td colSpan={15}>
//                     <Text fontWeight="semibold">
//                       {/* {gruposAbertos[grupo] ? <ChevronDownIcon /> : <ChevronRightIcon />} {grupo || "Não Agrupado"} */}
//                       {gruposAbertos[grupo] ? '−' : '+'}{grupo || "Não Agrupado"}
//                     </Text>
//                   </Td>
//                 </Tr>

//                 {gruposAbertos[grupo] && (
//                   <>
//                     {filtered.map((dado, idx) => {
//                       const mesValues = dado.Meses.map((mes, i) => {
//                         const value = mes.ValorTotalPago?.ValorTotalPago || 0;
//                         totalValues[i] += value;
//                         totalgeralfalse[i] = (totalgeralfalse[i] || 0) + value;
//                         return (
//                           <Td
//                             key={i}
//                             cursor="pointer"
//                             _hover={{ bg: "blue.200" }}
//                             onClick={() => buscarDetalhes({
//                               empresaID: dado.EmpresaID,
//                               planoDeConta: dado.PlanoDeConta,
//                               despesa: dado.Despesa,
//                               mes: mes.Mes,
//                               ano: filtros.ano,
//                               tipoData: filtros.tipoData,
//                               user: filtros.user
//                             })}
//                           >
//                             {formatarValor(value)}
//                           </Td>
//                         );
//                       });

//                       return (
//                         <Tr key={idx}>
//                           <Td></Td>
//                           <Td>{dado.PlanoDeConta}</Td>
//                           {mesValues}
//                           <Td>{formatarValor(somarArray(mesValues.map(td => parseFloat(td.props.children.replace(".", "").replace(",", ".")))))}</Td>
//                         </Tr>
//                       );
//                     })}
//                     <Tr bg="red.100">
//                       <Td></Td>
//                       <Td><Text fontWeight="bold">Total</Text></Td>
//                       {totalValues.map((v, i) => (
//                         <Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>
//                       ))}
//                       <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
//                     </Tr>
//                   </>
//                 )}
//               </React.Fragment>
//             );
//           })}
//         </Tbody>

//         {/* TOTAL BALANÇO */}
//         <Tbody>
//           <Tr bg="gray.200">
//             <Td></Td>
//             <Td><Text fontWeight="bold">Total</Text></Td>
//             {meses.map((_, i) => {
//               const receita = totalReceitasPorMes[i] || 0;
//               const despesa = totalDespesasPorMes[i] || 0;
//               return (
//                 <Td key={i}><Text fontWeight="bold">{formatarValor(receita - despesa)}</Text></Td>
//               );
//             })}
//             <Td>
//               <Text fontWeight="bold">
//                 {formatarValor(somarArray(totalReceitasPorMes) - somarArray(totalDespesasPorMes))}
//               </Text>
//             </Td>
//           </Tr>
//         </Tbody>
//       </Table>

//       {/* Modal para Detalhes */}


//       <Modal isOpen={isOpen} onClose={onClose} size="5xl">
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Lançamentos Detalhados</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             <Table size="sm" mt={4}>
//               <Thead>
//                 <Tr>
//                   <Th>Codigo</Th>
//                   <Td>Cliente/Fornecedor</Td>
//                   <Td>Banco</Td>
//                   <Td>Centro de Custo</Td>
//                   <Td>Plano de Conta</Td>
//                   <Td>Numero do Documento</Td>
//                   <Th>Data Vencimento</Th>
//                   <Th>Data Competencia</Th>
//                   <Th>Valor</Th>
//                 </Tr>
//               </Thead>
//               <Tbody>
//                 {detalhesModal.map((item, i) => (
//                   <Tr key={i}>
//                     <Td>{item.CodigoSequencial}</Td>
//                     <Td>{item.Cliente}</Td>
//                     <Td>{item.Banco}</Td>
//                     <Td>{item.CentroDeCusto}</Td>
//                     <Td>{item.PlanoDeConta}</Td>
//                     <Td>{item.NumeroDocumento}</Td>
//                     <Td>{new Date(item.DataCompetencia).toLocaleDateString()}</Td>
//                     <Td>{new Date(item.DataCompetencia).toLocaleDateString()}</Td>
//                     {/* <Td>{new Date(item[filtros.tipoData ? filtros.tipoData : 'DataCompetencia']).toLocaleDateString()}</Td> */}
//                     <Td>{formatarValor(item.Entrada || item.Saida || item.ValorPago)}</Td>
//                   </Tr>
//                 ))}
//               </Tbody>
//               <Tfoot>
//                 <Tr>
//                   <Td colSpan="3" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</Td>
//                   <Td style={{ fontWeight: 'bold' }}>{formatarValor(totalModal)}</Td>
//                 </Tr>
//               </Tfoot>
//             </Table>
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// }

// export default TabelaFinanceira;

import React, { useState } from "react";
import {
  Table, Thead, Tbody, Tr, Th, Td, Tfoot,
  Box, Text, Modal, ModalOverlay, ModalContent,
  ModalHeader, ModalCloseButton, ModalBody, useDisclosure
} from "@chakra-ui/react";
import api from 'contexts/api';

function somarArray(array) {
  return array.reduce((acc, val) => acc + val, 0);
}

function TabelaFinanceira({ dados, filtros }) {
  const [showReceitas, setShowReceitas] = useState(false);
  const [showDespesas, setShowDespesas] = useState(false);
  const [gruposAbertos, setGruposAbertos] = useState({});
  const [detalhesModal, setDetalhesModal] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();

  const toggleGrupo = (grupo) => {
    setGruposAbertos((prev) => ({
      ...prev,
      [grupo]: !prev[grupo]
    }));
  };

  const totalModal = detalhesModal.reduce((acc, item) => {
    const valor = item.Entrada || item.Saida || item.ValorPago || 0;
    return acc + valor;
  }, 0);

  const meses = [
    "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

  const gruposDRE = [...new Set(dados.map((dado) => (dado.GrupoDRE ?? "").trim()))];
  const gruposTrue = gruposDRE.filter((grupo) =>
    dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && dado.Despesa)
  );
  const gruposFalse = gruposDRE.filter((grupo) =>
    dados.some((dado) => ((dado.GrupoDRE ?? "").trim()) === grupo && !dado.Despesa)
  );

  const formatarValor = (valor) => {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(valor || 0);
  };

  const buscarDetalhes = async (params) => {
    try {
      const response = await api.get('/planodeconta/detalhe', { params });
      setDetalhesModal(response.data || []);
      onOpen();
    } catch (err) {
      console.error("Erro ao buscar detalhes:", err);
    }
  };

  const totalReceitasPorMes = Array(meses.length).fill(0);
  const totalDespesasPorMes = Array(meses.length).fill(0);

  dados.forEach(dado => {
    if (!dado.Meses || !Array.isArray(dado.Meses)) return;

    dado.Meses.forEach((mes, i) => {
      const value = mes.ValorTotalPago?.ValorTotalPago || 0;
      if (dado.Despesa) {
        totalDespesasPorMes[i] += value;
      } else {
        totalReceitasPorMes[i] += value;
      }
    });
  });

  return (
    <Box bg="white" p={4} rounded="xl" shadow="lg" mb={10}>
      <Table variant="striped" size="sm" borderWidth="1px" borderColor="gray.200">
        <Thead>
          <Tr bg="#0B1957">
            <Th textAlign="center" color="white">Grupo DRE</Th>
            <Th textAlign="center" color="white">Plano de Conta</Th>
            {meses.map((mes, i) => (
              <Th key={i} textAlign="center" color="white">{mes}</Th>
            ))}
            <Th textAlign="center" color="white">Total Ano</Th>
          </Tr>
        </Thead>

        <Tbody>
          {/* RECEITAS */}
          <Tr bg="#E6F0FF" cursor="pointer" onClick={() => setShowReceitas(!showReceitas)}>
            <Td colSpan={15}>
              <Text fontWeight="bold" color="#0B1957" fontSize="lg">
                {showReceitas ? '−' : '+'} Receitas (+)
              </Text>
            </Td>
          </Tr>

          {showReceitas && gruposFalse.map((grupo) => {
            const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && !d.Despesa);
            const totalValues = Array(meses.length).fill(0);
            return (
              <React.Fragment key={grupo}>
                <Tr bg="#F7FAFF" cursor="pointer" onClick={() => toggleGrupo(grupo)}>
                  <Td colSpan={15}><Text fontWeight="semibold">{gruposAbertos[grupo] ? '−' : '+'} {grupo || "Não Agrupado"}</Text></Td>
                </Tr>

                {gruposAbertos[grupo] && (
                  <>
                    {filtered.map((dado, idx) => {
                      const mesValues = dado.Meses.map((mes, i) => {
                        const value = mes.ValorTotalPago?.ValorTotalPago || 0;
                        totalValues[i] += value;
                        return (
                          <Td key={i} cursor="pointer" _hover={{ bg: "#EEF4FF" }}
                            onClick={() => buscarDetalhes({
                              empresaID: dado.EmpresaID,
                              planoDeConta: dado.PlanoDeConta,
                              despesa: dado.Despesa,
                              mes: mes.Mes,
                              ano: filtros.ano,
                              tipoData: filtros.tipoData,
                              user: filtros.user
                            })}>
                            {formatarValor(value)}
                          </Td>
                        );
                      });

                      return (
                        <Tr key={idx}>
                          <Td></Td>
                          <Td>{dado.PlanoDeConta}</Td>
                          {mesValues}
                          <Td>{formatarValor(somarArray(dado.Meses.map(m => m.ValorTotalPago?.ValorTotalPago || 0)))}</Td>
                        </Tr>
                      );
                    })}
                    <Tr bg="#C7DBFF">
                      <Td></Td>
                      <Td><Text fontWeight="bold">Subtotal</Text></Td>
                      {totalValues.map((v, i) => (<Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>))}
                      <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
                    </Tr>
                  </>
                )}
              </React.Fragment>
            );
          })}

          {/* Total Receitas */}
          <Tr bg="#C7DBFF">
            <Td></Td>
            <Td><Text fontWeight="bold">Total Receitas</Text></Td>
            {totalReceitasPorMes.map((v, i) => (<Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>))}
            <Td><Text fontWeight="bold">{formatarValor(somarArray(totalReceitasPorMes))}</Text></Td>
          </Tr>
        </Tbody>

        <Tbody>
          {/* DESPESAS */}
          <Tr bg="#FDECEC" cursor="pointer" onClick={() => setShowDespesas(!showDespesas)}>
            <Td colSpan={15}>
              <Text fontWeight="bold" color="#B91C1C" fontSize="lg">
                {showDespesas ? '−' : '+'} Despesas (-)
              </Text>
            </Td>
          </Tr>

          {showDespesas && gruposTrue.map((grupo) => {
            const filtered = dados.filter(d => (grupo ? d.GrupoDRE === grupo : !d.GrupoDRE) && d.Despesa);
            const totalValues = Array(meses.length).fill(0);
            return (
              <React.Fragment key={grupo}>
                <Tr bg="#FFF5F5" cursor="pointer" onClick={() => toggleGrupo(grupo)}>
                  <Td colSpan={15}><Text fontWeight="semibold">{gruposAbertos[grupo] ? '−' : '+'} {grupo || "Não Agrupado"}</Text></Td>
                </Tr>

                {gruposAbertos[grupo] && (
                  <>
                    {filtered.map((dado, idx) => {
                      const mesValues = dado.Meses.map((mes, i) => {
                        const value = mes.ValorTotalPago?.ValorTotalPago || 0;
                        totalValues[i] += value;
                        return (
                          <Td key={i} cursor="pointer" _hover={{ bg: "#FDEDED" }}
                            onClick={() => buscarDetalhes({
                              empresaID: dado.EmpresaID,
                              planoDeConta: dado.PlanoDeConta,
                              despesa: dado.Despesa,
                              mes: mes.Mes,
                              ano: filtros.ano,
                              tipoData: filtros.tipoData,
                              user: filtros.user
                            })}>
                            {formatarValor(value)}
                          </Td>
                        );
                      });

                      return (
                        <Tr key={idx}>
                          <Td></Td>
                          <Td>{dado.PlanoDeConta}</Td>
                          {mesValues}
                          <Td>{formatarValor(somarArray(dado.Meses.map(m => m.ValorTotalPago?.ValorTotalPago || 0)))}</Td>
                        </Tr>
                      );
                    })}
                    <Tr bg="#FFD6D6">
                      <Td></Td>
                      <Td><Text fontWeight="bold">Subtotal</Text></Td>
                      {totalValues.map((v, i) => (<Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>))}
                      <Td><Text fontWeight="bold">{formatarValor(somarArray(totalValues))}</Text></Td>
                    </Tr>
                  </>
                )}
              </React.Fragment>
            );
          })}

          {/* Total Despesas */}
          <Tr bg="#FFD6D6">
            <Td></Td>
            <Td><Text fontWeight="bold">Total Despesas</Text></Td>
            {totalDespesasPorMes.map((v, i) => (<Td key={i}><Text fontWeight="bold">{formatarValor(v)}</Text></Td>))}
            <Td><Text fontWeight="bold">{formatarValor(somarArray(totalDespesasPorMes))}</Text></Td>
          </Tr>
        </Tbody>

        {/* BALANÇO FINAL */}
        <Tbody>
          <Tr bg="#F3F4F6">
            <Td></Td>
            <Td><Text fontWeight="bold">Saldo (Receitas - Despesas)</Text></Td>
            {meses.map((_, i) => {
              const receita = totalReceitasPorMes[i] || 0;
              const despesa = totalDespesasPorMes[i] || 0;
              return (
                <Td key={i}><Text fontWeight="bold">{formatarValor(receita - despesa)}</Text></Td>
              );
            })}
            <Td><Text fontWeight="bold">{formatarValor(somarArray(totalReceitasPorMes) - somarArray(totalDespesasPorMes))}</Text></Td>
          </Tr>
        </Tbody>
      </Table>

      {/* Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="5xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Lançamentos Detalhados</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Table size="sm" mt={4}>
              <Thead>
                <Tr>
                  <Th>Código</Th>
                  <Th>Cliente/Fornecedor</Th>
                  <Th>Banco</Th>
                  <Th>Centro de Custo</Th>
                  <Th>Plano de Conta</Th>
                  <Th>Número do Documento</Th>
                  <Th>Data Vencimento</Th>
                  <Th>Data Competência</Th>
                  <Th>Valor</Th>
                </Tr>
              </Thead>
              <Tbody>
                {detalhesModal.map((item, i) => (
                  <Tr key={i}>
                    <Td>{item.CodigoSequencial}</Td>
                    <Td>{item.Cliente}</Td>
                    <Td>{item.Banco}</Td>
                    <Td>{item.CentroDeCusto}</Td>
                    <Td>{item.PlanoDeConta}</Td>
                    <Td>{item.NumeroDocumento}</Td>
                    <Td>{new Date(item.DataVencimento).toLocaleDateString()}</Td>
                    <Td>{new Date(item.DataCompetencia).toLocaleDateString()}</Td>
                    <Td>{formatarValor(item.Entrada || item.Saida || item.ValorPago)}</Td>
                  </Tr>
                ))}
              </Tbody>
              <Tfoot>
                <Tr>
                  <Td colSpan="8" style={{ textAlign: 'right', fontWeight: 'bold' }}>Total:</Td>
                  <Td style={{ fontWeight: 'bold' }}>{formatarValor(totalModal)}</Td>
                </Tr>
              </Tfoot>
            </Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  );
}

export default TabelaFinanceira;
